import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'letter-u', 'IconLetterU', [["path",{"d":"M6 4v11a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-11","key":"svg-0"}]]);